// Approved translations for the Airtable "Dietary Restriction" options.
// Source: SF New Deal master translations doc (Dietary Restrictions tab).
// Keyed by the canonical English label (the half before "/" in the combined
// "English/中文" values Airtable stores). Each entry carries es/zh/ar; there is
// no approved Vietnamese yet, so `vi` falls back to English.
export const DIETARY_TRANSLATIONS = {
  'No Restrictions':      { es: 'Sin restricciones dietéticas', zh: '沒有飲食禁忌', ar: 'لا يوجد قيود غذائية' },
  'Vegetarian':           { es: 'Vegetariano', zh: '素食', ar: 'نباتي' },
  'Vegan':                { es: 'Vegano', zh: '全素食，不含蛋奶', ar: 'نباتي صرف' },
  'Nut Allergy':          { es: 'Alergia (Nueces)', zh: '堅果過敏', ar: 'حساسية المكسرات' },
  'Seafood Allergy':      { es: 'Alergia (Mariscos)', zh: '海鮮過敏', ar: 'حساسية من المأكولات البحرية' },
  'Lactose Intolerant':   { es: 'Intolerante a Lactosa', zh: '乳糖不耐受', ar: 'عدم تحمل اللاكتوز' },
  'Gluten Allergy':       { es: 'Alergia (Gluten)', zh: '麩質過敏', ar: 'حساسية الغلوتين أو القمح' },
  'Diabetic':             { es: 'Diabético', zh: '糖尿病患者', ar: 'مريض سكري' },
  'Halal':                { es: 'Halal', zh: '清真', ar: 'حلال' },
  'No Pork':              { es: 'Sin Cerdo', zh: '不要豬肉', ar: 'بدون لحم خنزير' },
  'Citrus Allergy':       { es: 'Alergia (Cítricos)', zh: '柑橘類過敏', ar: 'حساسية الحمضيات' },
  'No Egg':               { es: 'Sin Huevo', zh: '不要雞蛋', ar: 'بدون بيض' },
  'Soy Allergy':          { es: 'Alergia (Soja)', zh: '豆製品過敏', ar: 'حساسية الصويا' },
  'Avocado Allergy':      { es: 'Alergia (Aguacate)', zh: '牛油果過敏', ar: 'حساسية الأفوكادو' },
  'Scallop Allergy':      { es: 'Alergia (Vieiras)', zh: '扇貝過敏', ar: 'حساسية من الإسكالوب' },
  'Cinnamon Allergy':     { es: 'Alergia (Canela)', zh: '肉桂過敏', ar: 'حساسية القرفة' },
  'Grapeseed Oil Allergy':{ es: 'Alergia (Aceite de Semilla de Uva)', zh: '葡萄籽油過敏', ar: 'حساسية زيت بذور العنب' },
  'Pineapple Allergy':    { es: 'Alergia (Piña)', zh: '菠蘿過敏', ar: 'حساسية الأناناس' },
  'Honey Allergy':        { es: 'Alergia (Miel)', zh: '蜂蜜過敏', ar: 'حساسية العسل' },
  'Fava Beans Allergy':   { es: 'Alergia (Habas)', zh: '蠶豆', ar: 'حساسية الفول' },
  'Tomato Allergy':       { es: 'Alergia (Tomate)', zh: '番茄過敏', ar: 'حساسية الطماطم' },
  'Other Allergy':        { es: 'Otras Alergias', zh: '其他過敏', ar: 'حساسية أخرى' },
  'No Beef':              { es: 'Sin Carne de Res', zh: '不要牛肉', ar: 'بدون لحم بقري' },
};

// Map a list of Airtable dietary values to the active language.
// Airtable stores each value as "English/中文". We use the English half as the
// translation key. en/vi → English; es/zh/ar → the approved translation, with a
// graceful fallback to the raw Chinese half (zh) or English when a value isn't
// in the map (e.g. a newly added option not yet translated).
export function localizeDietary(values, lang) {
  if (!Array.isArray(values)) return [];
  return values
    .filter((v) => typeof v === 'string' && v.trim())
    .map((v) => {
      const idx = v.indexOf('/');
      const en = (idx === -1 ? v : v.slice(0, idx)).trim();
      if (lang === 'en' || lang === 'vi') return en;
      const tr = DIETARY_TRANSLATIONS[en];
      if (tr && tr[lang]) return tr[lang];
      if (lang === 'zh' && idx !== -1) return v.slice(idx + 1).trim();
      return en;
    });
}
